import React from 'react';
import type {
  IProGalleryProps,
  IProGalleryImperativeActions,
} from '../../../ProGallery.types';
import ProGalleryCommon from '../../ProGalleryCommon';
import { st, classes } from '../../style/ProGallery.component.st.css';

const ProGallerySkin: React.ForwardRefRenderFunction<
  IProGalleryImperativeActions,
  IProGalleryProps
> = (props, ref) => {
  const skinClassNames = {
    container: st(classes.container),
    root: st(classes.root),
  };
  return <ProGalleryCommon {...props} skinClasses={skinClassNames} ref={ref} />;
};

export default React.forwardRef(ProGallerySkin);
